import DeadlineArrayField from './DeadlineArrayField.component';

export default DeadlineArrayField;